module.exports = window.XMLHttpRequest;
